<template>
	<div
		id="docSubtype-detail"
		:class="[!isWeb ? 'mobile-docSubtype-detail' : '', !isWeb && isSafari ? 'safari' : '']"
	>
		<div class="detail-title">
			<div class="detail-title__icon" @click="goToDocSubtypes()">
				<SidebarArrow :border="'#0047ff'" />
			</div>
			<h1 class="detail-title__text">
				{{ !$route.query.id ? 'Adicionar Subtipo de documentos' : 'Editar Subtipo de documentos' }}
			</h1>
		</div>
		<DocSubtypeForm :isWeb="isWeb" />
	</div>
</template>

<script>
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import DocSubtypeForm from '@/components/modules/DocSubtype/DocSubtypeDetail/DocSubtypeForm/DocSubtypeForm.vue';

export default {
	name: 'DocSubtypeDetail',
	components: { SidebarArrow, DocSubtypeForm },
	data: () => ({
		windowWidth: window.innerWidth,
	}),
	created() {},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		goToDocSubtypes() {
			this.$router.push({ path: '/dashboard/config/docSubtype' });
		},
	},
	computed: {
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss">
@import 'DocSubtypeDetail.scss';
</style>
